export default [
    'ShoppingCart.refreshCount',
    'ShoppingCart.persist',
    'ShoppingCart.persistState',
    'ShoppingCart.selectedPlansMap0',
    'SignUp.account',
    'SignUp.zuoraInfo',
    'SignUp.agreements',
    'SignUp.signInSource',
    'ShoppingCart.currentEditPlan',
    'Coupon.couponState',
    'Coupon.verifyCouponStatus',
    'Coupon.supportCouponState',
    'SmsVerify.verificationDetail',
    'ShoppingCart._healthcareInfo',
    'SignUp.lookupInfo',
    'ShoppingCart.trialInfoMap',
    'ShoppingCart.draftPlanFilterKeys',
    'ShoppingCart.initialPlanCodes',
    'Payment.isPayMethodReAdded',
    'Address.shippingInfo',
    'Address.confirmContinueWithErrorPhone'
];
